<div class="PageContent">

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteProductQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteProductQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteProductQuestion = false;DeleteIndustryProductStockOffer();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <!-- ✅ Export Stock Popup - ModernPopup style -->
  <div class="ModernPopupOverlay" *ngIf="ShowExportStockQuestion" (click)="ShowExportStockQuestion = false;">
    <div class="ModernPopup small" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons" style="color: #32aa3a;">downloading</i>
          <span>{{ 'ExportStockQuestion' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowExportStockQuestion = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <!-- Body -->
      <div class="ModernPopupBody" style="min-height: auto; max-height: auto; padding: 24px;">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">info_outline</i>
          {{ 'ExportStockDescription' | translate }}
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'ExportIndustryProductsStockValuesType' | translate }}</label>
          <mat-form-field appearance="outline" class="ModernFormInput" style="width: 100%;">
            <mat-select name="ExportIndustryProductsStockValuesType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ExportIndustryProductsStockValuesType">
              <mat-option *ngFor="let t of this.ExportIndustryProductsStockValuesTypes" [value]="t">
                {{t.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'ExportLanguage' | translate }}</label>
          <mat-form-field appearance="outline" class="ModernFormInput" style="width: 100%;">
            <mat-select name="ExportLanguage" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ExportLanguage">
              <mat-option *ngFor="let l of this.Languages" [value]="l">
                {{l.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Footer -->
      <div class="ModernPopupFooter" style="display: flex; gap: 12px; justify-content: flex-end; padding: 16px 20px; border-top: 1px solid #d0e0f5; background: #f8fbfe; border-radius: 0 0 24px 24px;">
        <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowExportStockQuestion = false;">
          {{ 'Configuration.DeleteNoButton' | translate }}
        </button>
        <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="ExportStockByType();">
          <i class="material-icons" *ngIf="!this.parent.loading">file_download</i>
          <mat-spinner *ngIf="this.parent.loading" [diameter]="18" style="margin-right: 8px;"></mat-spinner>
          {{ 'ExportStocks' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="NewProductContainer ModernPanel animated fadeInDown" *ngIf="ShowNewStockEntryContainer == true;">
    <div class="NewProductContainerTitleBar">
      <p *ngIf="this.NewProduct.ID == 0;">{{'AddStockEntry' | translate}}</p>
      <p *ngIf="this.NewProduct.ID > 0;">{{'UpdateStockEntry' | translate}}: {{this.NewProduct.Brand.Name}} {{this.NewProduct.Name}}</p>
      <i class="material-icons" (click)="ShowNewStockEntryContainer = false;">close</i>
    </div>
    <div class="NewProductContainerBody">
      <div class="TwoThirdsColumn">

        <div class="ModernFormSectionTitle">
          <i class="material-icons">radio_button_checked</i>
          {{'GeneralInformation' | translate}}
        </div>

        <div class="ModernSearchContainer">
          <div class="ModernSearchBar">
            <i class="material-icons search-icon">search</i>
            <input type="text" class="ModernSearchInput" placeholder="{{'SearchProducts' | translate}}" autocomplete="off" (click)="InitializeSearchProduct();" [(ngModel)]="this.SearchTerm" (ngModelChange)="this.productSearchTermUpdate.next($event)">
            <i class="material-icons clear-icon" *ngIf="this.SearchTerm?.length > 0;" (click)="ClearSearchIndustryProducts();">close</i>
          </div>
          <div class="ModernSearchResults" *ngIf="this.SearchedProducts?.length > 0">
            <div class="ModernSearchResultItem" *ngFor="let p of this.SearchedProducts" (click)="GetIndustryProductByID(p.ProductID, true);">
              <span class="ModernSearchResultTitle">
                {{p.FKBrandName}} {{p.ProductName}}
              </span>
              <span class="ModernSearchResultSub">
                {{p.ProductPartNumber}}
              </span>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'Name' | translate }}*</label>
          <input disabled class="ModernFormInput" placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.NewProduct.Name">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'PartNumber' | translate }}</label>
          <input disabled class="ModernFormInput" placeholder="{{ 'PartNumber' | translate }}" autocomplete="off" [(ngModel)]="this.NewProduct.PartNumber">
        </div>

        <div class="ModernAutocompleteContainer">
          <label class="ModernFormLabel">{{'SelectBrand' | translate}}*</label>
          <div class="ModernAutocompleteBar">
            <i class="material-icons search-icon" *ngIf="(this.NewProduct.Brand?.Name?.length > 0) != true;">search</i>
            <input disabled class="ModernAutocompleteInput"
                   type="text"
                   placeholder="{{'SelectBrand' | translate}}"
                   [matAutocomplete]="auto1"
                   [(ngModel)]="this.NewProduct.Brand.Name"
                   (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                   (click)="InitializeBrands();">
          </div>
          <mat-autocomplete #auto1="matAutocomplete">
            <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.NewProduct.Brand = brand;">
              {{brand.Name}}
            </mat-option>
          </mat-autocomplete>
        </div>

      </div>

      <div class="OneThirdColumn">
      </div>

      <div class="ModernFormDivider"></div>

      <div class="TwoThirdsColumn">
        <div class="ModernFormSectionTitle">
          <i class="material-icons">account_tree</i>
          {{'StockInfo' | translate}}
        </div>

        <div class="ModernAutocompleteContainer" matTooltip="{{ 'ConfigurationWarehouseDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
          <label class="ModernFormLabel">{{'SelectWarehouse' | translate}}</label>
          <div class="ModernAutocompleteBar">
            <i class="material-icons search-icon" *ngIf="(this.Configuration.Warehouse?.Name?.length > 0) != true;">search</i>
            <input id="warehouseselectid" class="ModernAutocompleteInput"
                   type="text"
                   placeholder="{{'SelectWarehouse' | translate}}"
                   [matAutocomplete]="auto4"
                   [(ngModel)]="this.ConfigurationWarehouseName"
                   (ngModelChange)="this.warehouseSearchTermUpdate.next($event)"
                   (click)="InitializeWarehouses();">
          </div>
          <mat-autocomplete #auto4="matAutocomplete">
            <mat-option *ngFor="let warehouse of this.Warehouses" [value]="warehouse" (click)="this.Configuration.Warehouse = warehouse; this.ConfigurationWarehouseName = warehouse.Name; GetImportConfigurationByWarehouse(warehouse.ID);">
              {{warehouse.Name}}
            </mat-option>
          </mat-autocomplete>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'LeadTimeType' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownBar" [class.open]="ShowLeadTimeTypeDropdown" [class.disabled]="this.Configuration?.Warehouse?.StockLeadTime?.Type != null" (click)="ShowLeadTimeTypeDropdown = !ShowLeadTimeTypeDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.Configuration.Warehouse.StockLeadTime.Type">
                {{this.Configuration.Warehouse.StockLeadTime.Type?.Name || ('LeadTimeType' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="ShowLeadTimeTypeDropdown">
              <div class="ModernDropdownOption" *ngFor="let t of this.LeadTimeTypes" [class.selected]="this.parent.compareFn(this.Configuration.Warehouse.StockLeadTime.Type, t)" (click)="this.Configuration.Warehouse.StockLeadTime.Type = t; ShowLeadTimeTypeDropdown = false;">
                {{t.Name}}
                <i class="material-icons check-icon" *ngIf="this.parent.compareFn(this.Configuration.Warehouse.StockLeadTime.Type, t)">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup" *ngIf="this.Configuration.Warehouse.StockLeadTime != null">
          <label class="ModernFormLabel">{{'Units' | translate}}</label>
          <input class="ModernFormInput" [disabled]="this.Configuration?.Warehouse?.StockLeadTime?.Units != null" placeholder="{{'Units' | translate}}" autocomplete="off" [(ngModel)]="this.Configuration.Warehouse.StockLeadTime.Units">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'ProductConditionStatus' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownBar" [class.open]="ShowConditionStatusDropdown" (click)="ShowConditionStatusDropdown = !ShowConditionStatusDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.ListPriceOffer.ConditionStatus">
                {{this.ListPriceOffer.ConditionStatus?.Name || ('ProductConditionStatus' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="ShowConditionStatusDropdown">
              <div class="ModernDropdownOption" *ngFor="let s of this.ProductConditionStatuses" [class.selected]="this.parent.compareFn(this.ListPriceOffer.ConditionStatus, s)" (click)="this.ListPriceOffer.ConditionStatus = s; ShowConditionStatusDropdown = false;">
                {{s.Name}}
                <i class="material-icons check-icon" *ngIf="this.parent.compareFn(this.ListPriceOffer.ConditionStatus, s)">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'ProductBoxStatus' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownBar" [class.open]="ShowBoxStatusDropdown" (click)="ShowBoxStatusDropdown = !ShowBoxStatusDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.ListPriceOffer.BoxStatus">
                {{this.ListPriceOffer.BoxStatus?.Name || ('ProductBoxStatus' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="ShowBoxStatusDropdown">
              <div class="ModernDropdownOption" *ngFor="let s of this.ProductBoxStatuses" [class.selected]="this.parent.compareFn(this.ListPriceOffer.BoxStatus, s)" (click)="this.ListPriceOffer.BoxStatus = s; ShowBoxStatusDropdown = false;">
                {{s.Name}}
                <i class="material-icons check-icon" *ngIf="this.parent.compareFn(this.ListPriceOffer.BoxStatus, s)">check</i>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="OneThirdColumn">

        <div class="ModernFormSectionTitle">
          <i class="material-icons">account_tree</i>
          {{'StockInfo' | translate}}
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'ListPrice' | translate}}</label>
          <input class="ModernFormInput" placeholder="{{'ListPrice' | translate}}" autocomplete="off" [(ngModel)]="this.ListPriceOffer.ListPrice">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'DiscountedPrice' | translate}}</label>
          <input class="ModernFormInput" placeholder="{{'DiscountedPrice' | translate}}" autocomplete="off" [(ngModel)]="this.ListPriceOffer.DiscountedPrice">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'StockQuantity' | translate}}</label>
          <input class="ModernFormInput" placeholder="{{'StockQuantity' | translate}}" autocomplete="off" [(ngModel)]="this.ListPriceOffer.StockQuantity">
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{ 'Currency' | translate }}</label>
          <div class="ModernDropdownContainer">
            <div class="ModernDropdownBar" [class.open]="ShowCurrencyDropdown" (click)="ShowCurrencyDropdown = !ShowCurrencyDropdown">
              <span class="ModernDropdownText" [class.placeholder]="!this.ListPriceOffer.Currency">
                {{this.ListPriceOffer.Currency?.Name || ('Currency' | translate)}}
              </span>
              <i class="material-icons ModernDropdownArrow">expand_more</i>
            </div>
            <div class="ModernDropdownResults" *ngIf="ShowCurrencyDropdown">
              <div class="ModernDropdownOption" *ngFor="let c of this.Currencies" [class.selected]="this.parent.compareFn(c, this.ListPriceOffer.Currency)" (click)="this.ListPriceOffer.Currency = c; ShowCurrencyDropdown = false;">
                {{c.Name}}
                <i class="material-icons check-icon" *ngIf="this.parent.compareFn(c, this.ListPriceOffer.Currency)">check</i>
              </div>
            </div>
          </div>
        </div>

        <div class="ModernFormGroup">
          <label class="ModernFormLabel">{{'MOQ' | translate}}</label>
          <input class="ModernFormInput" placeholder="{{'MOQ' | translate}}" autocomplete="off" [(ngModel)]="this.ListPriceOffer.MOQ">
        </div>

      </div>
    </div>
    <div class="NewProductContainerCommands">
      <div class="GridCommandButton GridCommandButtonGreen" style="float: left; margin-left: 15px; margin-top: 7px;" *ngIf="this.ListPriceOffer.ID == 0;" (click)="AddUpdateListPriceOffer(this.ListPriceOffer);">
        <i class="material-icons">add</i>
        <span>{{'AddStockEntry' | translate}}</span>
      </div>

      <div class="GridCommandButton GridCommandButtonBlue" style="float: left; margin-left: 15px; margin-top: 7px;" *ngIf="this.ListPriceOffer.ID > 0;" (click)="AddUpdateListPriceOffer(this.ListPriceOffer);">
        <i class="material-icons">edit</i>
        <span>{{'UpdateStockEntry' | translate}}</span>
      </div>
    </div>
  </div>

  <div class="overlayTransparent animated fadeIn" *ngIf="ShowFilter == true;" (click)="CloseOverlay();"></div>
  <div class="overlay animated fadeIn" *ngIf="ShowNewStockEntryContainer || ShowDeleteProductQuestion" (click)="CloseDashMenu();" style="z-index: 202;"></div>

  <div class="PageContentTitle">
      <div class="PageContentTitleIntro">
          <i class="material-icons">account_tree</i>
          <p class="PageContentTitleParagraph">{{'StockProducts' | translate}}</p>
      </div>

      <div class="ModernStockSearchContainer">
        <div class="ModernStockSearchBar">
          <i class="material-icons search-icon">search</i>
          <input type="text" class="ModernStockSearchInput" placeholder="{{'SearchStockProducts' | translate}}" autocomplete="off" [(ngModel)]="this.SearchBarTerm" (ngModelChange)="this.searchTermUpdate.next($event)">
          <i class="material-icons clear-icon" *ngIf="this.SearchBarTerm?.length > 0;" (click)="ClearSearchBar();">close</i>
        </div>
      </div>

      <div class="PageContentTitleCommands" style="display: flex; align-items: center; gap: 6px; padding-top: 14px;">
          <div class="GridCommandButton" (click)="ShowFilter = !ShowFilter;" style="position: relative;">
              <i class="material-icons">filter_alt</i>
              <span>{{'Filter' | translate}}</span>
              <span class="ButtonNotification" *ngIf="activeFilters.length > 0;">{{activeFilters.length}}</span>
          </div>

          <div class="GridCommandButton GridCommandButtonGreen" (click)="InitializeNewStockEntry();">
              <i class="material-icons">add</i>
              <span>{{'NewStock' | translate}}</span>
          </div>

          <div class="GridCommandButton GridCommandButtonBlue" (click)="ShowExportStockQuestion = true;">
            <i class="material-icons">downloading</i>
            <span>{{'ExportStocks' | translate}}</span>
          </div>

          <div class="ButtonFilterContainer animated fadeIn" *ngIf="ShowFilter == true;">
              <i class="material-icons ButtonFilterContainerCloseIcon" (click)="ShowFilter = false;">close</i>
              <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.FilterLoading == true;"></mat-spinner>
              
              <div *ngIf="this.FilterLoading != true;">
                  <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerOneThirdColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductBoxStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductBoxStatus">
                            <mat-option *ngFor="let s of this.ProductBoxStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductBoxStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductConditionStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductConditionStatus">
                            <mat-option *ngFor="let s of this.ProductConditionStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductConditionStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                  </div>

                  <div class="ButtonFilterContainerRow">
                      <div class="ButtonFilterContainerOneThirdColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductManufacturingStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductManufacturingStatus">
                            <mat-option *ngFor="let s of this.ProductManufacturingStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductManufacturingStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">
                        <mat-form-field class="ButtonFilterDropDown" appearance="outline" style="width: 80%;">
                          <mat-label>{{'ProductVersionStatus' | translate}}</mat-label>
                          <mat-select name="Company" [(ngModel)]="Filter.ProductVersionStatus">
                            <mat-option *ngFor="let s of this.ProductVersionStatuses;" [value]="s" (click)="AddActiveFilter(s.Name, 'ProductVersionStatus');">
                              {{s.Name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                  </div>

                  <div class="ButtonFilterContainerRow">
                    <div class="ButtonFilterContainerOneThirdColumn">
                    
                    </div>
                    <div class="ButtonFilterContainerTwoThirdsColumn">
                    
                    </div>
                  </div>

                  <div class="ButtonFilterContainerRow" style="padding-left: 3%;height: auto;min-height: 60px;padding-top: 10px;">
                    <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
                      {{a.Name}}
                      <i class="material-icons ActiveFilterIcon">close</i>
                    </div>
                  </div>

                  <div class="ButtonFilterContainerRow" style="margin-bottom: 15px;">
                      <div class="ButtonFilterContainerOneThirdColumn">
                          <div class="GridCommandButton GridCommandButtonBlue" style="width: 80%; margin-left: 10%;" (click)="ShowFilter = false; ApplyFilters();">
                              <i class="material-icons">check</i>
                              <span>{{'ApplyFilter' | translate}}</span>
                          </div>
                      </div>
                      <div class="ButtonFilterContainerTwoThirdsColumn">

                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>

    <div class="GridModeTabsWrapper">
      <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': SelectedStockTab === 'Stock-Products'}" (click)="OnTabChange('Stock-Products')">
        <i class="material-icons">inventory</i>
        <span>{{'Stock-Products' | translate}}</span>
      </div>
      <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': SelectedStockTab === 'Added-Offers'}" (click)="OnTabChange('Added-Offers')">
        <i class="material-icons">add_circle</i>
        <span>{{'Added-Offers' | translate}}</span>
      </div>
    </div>

    <div class="PageContentBody animated fadeIn" *ngIf="SelectedStockTab === 'Stock-Products'">
      <div class="PageContentBodyTopCommands">
         
        <mat-form-field class="ButtonFilterDropDown" appearance="outline">
          <mat-label>{{'SelectWarehouse' | translate}}*</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectWarehouse' | translate}}"
                 matInput
                 [disabled]="true"
                 [(ngModel)]="this.FilterWarehouseName">
          <i class="material-icons BrandSelectCloseIcon">warehouse</i>
        </mat-form-field>

        <mat-form-field class="ButtonFilterDropDown" appearance="outline">
          <mat-label>{{'SelectBrand' | translate}}*</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 matInput
                 [matAutocomplete]="auto2"
                 [(ngModel)]="this.FilterBrandName"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                 (click)="InitializeBrands();">
          <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Filter.Brand?.Name?.length > 0;" (click)="ClearSearchBrand();">close</i>
          <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Filter.Brand?.Name?.length > 0) != true;">search</i>
          <mat-autocomplete #auto2="matAutocomplete">
            <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Filter.Brand = brand; this.FilterBrandName = this.Filter.Brand.Name; this.Filter.Pager.PageIndex = 1; GetIndustryProductsStocksFiltered(1);">
              {{brand.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

            <div class="TopLevelPaginator unSelectable">
              <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex - 1; GetIndustryProductsStocksFiltered(this.Filter.Pager.PageIndex);">
                <i class="material-icons">chevron_left</i>
              </div>
              <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_left</i>
              </div>

              <mat-form-field appearance="outline" class="TopLevelPaginatorTextBox">
                <mat-label>{{ 'PageSize' | translate }}*</mat-label>
                <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="this.Filter.Pager.PageIndex = 1; GetIndustryProductsStocksFiltered(1);">
              </mat-form-field>

              <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex + 1; GetIndustryProductsStocksFiltered(this.Filter.Pager.PageIndex);">
                <i class="material-icons">chevron_right</i>
              </div>
              <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
                <i class="material-icons">chevron_right</i>
              </div>

              <span class="pageInfoSpan">{{this.StockProducts?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'StockProducts' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
            </div>

            <div class="GridCommandButton GridCommandButtonBlue" style="float: right; margin-top: 14px; margin-right: 15px;" (click)="GetIndustryProductsStocksFiltered();">
              <i class="material-icons">check</i>
              <span>{{'ApplyFilter' | translate}}</span>
            </div>
      </div>

      <div class="PageContentBodyElementsContainer">
        <div class="TaskRow TaskHeadderRow">
          <div class="ProductsCol dottedRow" style="width: 3%;text-align:center;">
            #
          </div>
          <div class="ProductsCol" style="width: 25%;">
            {{'Name' | translate}}
          </div>
          <div class="ProductsCol" style="width: 18%;">
            {{'Properties' | translate}}
          </div>
          <div class="ProductsCol" style="width: 10%;">
            {{'Brand' | translate}}
          </div>
          <div class="ProductsCol" style="width: 9%;">
            {{'Warehouse' | translate}}
          </div>
          <div class="ProductsCol" style="width: 8%;text-align:center;">
            {{'Quantity' | translate}}
          </div>
          <div class="ProductsCol" style="width: 8%;text-align:center;">
            {{'LeadTime' | translate}}
          </div>
          <div class="ProductsCol" style="width: 7%;text-align:center;">
            {{'Currency' | translate}}
          </div>
          <div class="ProductsCol" style="width: 12%;text-align:center;">
            {{'SellingPrice' | translate}}
          </div>

        </div>

        <div class="ProductsContainer">
          <div class="ProductRow" *ngFor="let p of this.StockProducts; let i=index;" [ngClass]="{'OverduePopUp': p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0 }">
            <div class="ProductsColWarnBubble" *ngIf="p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0;">
            </div>
            <div style="background: #32aa3a;" class="ProductsColWarnBubble" *ngIf="!(p.ListPriceOffers[0]?.ConditionStatus?.ID > 0 || p.ListPriceOffers[0]?.BoxStatus?.ID > 0);">
            </div>
            <div class="ProductsCol dottedRow" style="width: 3%;text-align:center;">
              {{i + 1}}
            </div>
            <div class="ProductsCol" style="width: 25%;padding-top: 20px;">
              <p class="ProductsColMain" *ngIf="p.Brand != null;">
                {{p.Brand?.Name}}
              </p>
              <p class="ProductsColMain">
                <span style="font-size:15px;color: #0082e6;font-weight: 400;">{{p.Name}}</span>
              </p>
              <p class="ProductsColMain" *ngIf="p.PartNumber != null;">
                <span class="ProductsColMainSpan">{{'PartNumber' | translate}}: </span>
                {{p.PartNumber}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 18%;padding-top: 18px;">
              <p class="ProductsColMain" *ngIf="p.Stats?.HSCode != null;">
                <span class="ProductsColMainSpan">{{'HSCode' | translate}}: </span>
                {{p.Stats?.HSCode}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Stats?.COO != null;">
                <span class="ProductsColMainSpan">{{'COO' | translate}}: </span>
                {{p.Stats?.COO?.Name}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Stats?.EAN != null;">
                <span class="ProductsColMainSpan">{{'EAN' | translate}}: </span>
                {{p.Stats?.EAN}}
              </p>
              <p class="ProductsColMain" *ngIf="p.Stats?.Weight != null;">
                <span class="ProductsColMainSpan">{{'Weight' | translate}}: </span>
                {{p.Stats?.Weight}} {{p.Stats?.WeightMeasurementType?.Name}}
              </p>
              <p class="ProductsColMain">
                <span class="ProductsColMainSpan">{{'ProductManufacturingStatus' | translate}}: </span>
                {{p.ManufacturingStatus?.Name}}
              </p>
              <p class="ProductsColMain">
                <span class="ProductsColMainSpan">{{'ProductVersionStatus' | translate}}: </span>
                {{p.VersionStatus?.Name}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 10%;padding-top: 20px;">
              <p class="ProductsColMain" *ngIf="p.Brand != null;">
                {{p.Brand?.Name}}
              </p>
              <p class="ProductsColMain" *ngIf="p.ListPriceOffers[0]?.ConditionStatus != null;">
                {{p.ListPriceOffers[0]?.ConditionStatus.Name}}
              </p>
              <p class="ProductsColMain" *ngIf="p.ListPriceOffers[0]?.BoxStatus != null;">
                {{p.ListPriceOffers[0]?.BoxStatus.Name}}
              </p>
            </div>
            <div class="ProductsCol" style="width: 9%;">
              {{p.ListPriceOffers[0]?.Partner?.Name}}
            </div>
            <div class="ProductsCol" style="width: 8%;text-align:center;">
              <span class="StockQuantitySpan" [ngClass]="{'alertStock': p.ListPriceOffers[0]?.StockQuantity < 3, 'lowStock': p.ListPriceOffers[0]?.StockQuantity >= 3 && p.ListPriceOffers[0]?.StockQuantity <= 5, 'normalStock': p.ListPriceOffers[0]?.StockQuantity > 5 && p.ListPriceOffers[0]?.StockQuantity <= 15, 'bigStock': p.ListPriceOffers[0]?.StockQuantity > 15 }">{{p.ListPriceOffers[0]?.StockQuantity}}</span>
            </div>
            <div class="ProductsCol" style="width: 8%;text-align:center;">
              {{p.ListPriceOffers[0]?.LeadTime?.Units}} {{p.ListPriceOffers[0]?.LeadTime?.Type?.Name}}
            </div>
            <div class="ProductsCol" style="width: 7%;">
              <div class="InlinePriceContainer" *ngIf="p.ListPriceOffers?.length > 0">
                <select class="InlineCurrencySelect" [ngModel]="p.ListPriceOffers[0].Currency?.ID" (ngModelChange)="OnStockProductCurrencyChange(p, $event)">
                  <option *ngFor="let c of Currencies" [ngValue]="c.ID">{{c.Name}}</option>
                </select>
              </div>
            </div>
            <div class="ProductsCol" style="width: 12%;text-align:center;overflow:visible;">
              <div class="InlinePriceContainer">
                <input type="number" class="InlineSellingPriceInput" [(ngModel)]="p.ListPriceOffers[0].SellingPrice" placeholder="0.00" (click)="$event.target.select()">
                <div class="InlineSaveButton" (click)="SaveSellingPrice(p);" title="{{'SaveSellingPrice' | translate}}">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="PageContentBody animated fadeIn" *ngIf="SelectedStockTab === 'Added-Offers'">
      <div class="PageContentBodyTopCommands">

        <div class="TopLevelPaginator unSelectable">
          <div class="TopLevelPaginatorButton" *ngIf="this.AddedOffersFilter.Pager?.PageIndex != 1;" (click)="this.AddedOffersFilter.Pager.PageIndex = this.AddedOffersFilter.Pager.PageIndex - 1; GetAddedOffersFiltered(this.AddedOffersFilter.Pager.PageIndex);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopLevelPaginatorButton" *ngIf="this.AddedOffersFilter.Pager?.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <mat-form-field appearance="outline" class="TopLevelPaginatorTextBox">
            <mat-label>{{ 'PageSize' | translate }}*</mat-label>
            <input matInput autocomplete="off" [(ngModel)]="AddedOffersFilter.Pager.PageSize" (change)="this.AddedOffersFilter.Pager.PageIndex = 1; GetAddedOffersFiltered(1);">
          </mat-form-field>

          <div class="TopLevelPaginatorButton" *ngIf="this.AddedOffersFilter.Pager?.PageIndex != this.AddedOffersFilter.Pager?.Pages;" (click)="this.AddedOffersFilter.Pager.PageIndex = this.AddedOffersFilter.Pager.PageIndex + 1; GetAddedOffersFiltered(this.AddedOffersFilter.Pager.PageIndex);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopLevelPaginatorButton" *ngIf="this.AddedOffersFilter.Pager?.PageIndex == this.AddedOffersFilter.Pager?.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>

          <span class="pageInfoSpan">{{this.AddedOffersProducts?.length}} {{'OfWord' | translate}} {{this.AddedOffersFilter.Pager?.TotalCount}} {{'StockProducts' | translate}} ({{'Page' | translate}}: {{this.AddedOffersFilter.Pager?.PageIndex}} {{'OfWord' | translate}} {{this.AddedOffersFilter.Pager?.Pages}})</span>
        </div>

        <div class="GridCommandButton GridCommandButtonBlue" style="float: right; margin-top: 14px; margin-right: 15px;" (click)="GetAddedOffersFiltered();">
          <i class="material-icons">check</i>
          <span>{{'ApplyFilter' | translate}}</span>
        </div>
      </div>

      <div class="PageContentBodyElementsContainer">
        <div class="TaskRow TaskHeadderRow">
          <div class="ProductsCol dottedRow" style="width: 3%;text-align:center;">
            #
          </div>
          <div class="ProductsCol dottedRow" style="width: 24%;">
            {{'Name' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 14%;">
            {{'PartNumber' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 12%;">
            {{'Brand' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 10%;">
            {{'ListPrice' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 10%;">
            {{'DiscountedPrice' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 10%;">
            {{'SellingPrice' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 8%;">
            {{'StockQuantity' | translate}}
          </div>
          <div class="ProductsCol dottedRow" style="width: 9%;">
            {{'Currency' | translate}}
          </div>

        </div>

        <div *ngFor="let p of AddedOffersProducts; let i = index;">
          <div class="TaskRow">
            <div class="ProductsCol" style="width: 3%;text-align:center;">
              {{i + 1}}
            </div>
            <div class="ProductsCol" style="width: 24%;">
              {{p.Name}}
            </div>
            <div class="ProductsCol" style="width: 14%;">
              {{p.PartNumber}}
            </div>
            <div class="ProductsCol" style="width: 12%;">
              {{p.Brand?.Name}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{p.ListPriceOffers?.length > 0 ? p.ListPriceOffers[0].ListPrice : ''}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{p.ListPriceOffers?.length > 0 ? p.ListPriceOffers[0].DiscountedPrice : ''}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              <div class="InlinePriceContainer" *ngIf="p.ListPriceOffers?.length > 0">
                <input class="InlineSellingPriceInput" type="number" [(ngModel)]="p.ListPriceOffers[0].SellingPrice" placeholder="0.00" (click)="$event.target.select()">
                <div class="InlineSaveButton" (click)="SaveAddedOfferSellingPrice(p)" title="{{ 'Save' | translate }}">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
            <div class="ProductsCol" style="width: 8%;">
              {{p.ListPriceOffers?.length > 0 ? p.ListPriceOffers[0].StockQuantity : ''}}
            </div>
            <div class="ProductsCol" style="width: 9%;">
              <div class="InlinePriceContainer" *ngIf="p.ListPriceOffers?.length > 0">
                <select class="InlineCurrencySelect" [ngModel]="p.ListPriceOffers[0].Currency?.ID" (ngModelChange)="OnAddedOfferCurrencyChange(p, $event)">
                  <option *ngFor="let c of Currencies" [ngValue]="c.ID">{{c.Name}}</option>
                </select>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

</div>